import React, { useState, useEffect } from 'react';
import HeaderCardNew from '../../Components/HeaderCardNew';
import FlexibleCard from '../../Components/FlexibleCard';
import CarouselSmallCard from '../../Components/CarouselSmallCard';
import FeedbackCard from '../../Components/FeedbackCard';
import TopNavBarNew from "../../Components/TopNavBarNew";
import BottomNavBarNew from "../../Components/BottomNavBarNew";
import styles from '../AbortionWPills/PillAbortion.module.css';

export default function Condoms({ appLanguage }) {
  const [pageState, setPageState] = useState({
    // General Content
    headerTitle: '',
    pageTitle: '',
    extraText: '',
    extraText2: '',
    extraText3: '',

    // Individual Large Cards
    largeCard1: {},
    largeCard2: {},
    largeCard3: {},
    largeCard4: {},
    largeCard5: {},

    // Small Cards Section
    smallCardTitle1: '',
    smallCardDescription1: '',
    smallCardTitle2: '',
    smallCardDescription2: '',
  
    // Assets
    headerImage: '',
    arrowIconWhite: '',
    arrowIconDark: '',
    heartIcon: '',
    image1: '',
    image2: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Condoms';

    const entries = JSON.parse(localStorage.getItem('ayaAppEntries') || '[]');
    const assets = JSON.parse(localStorage.getItem('ayaAppAssets') || '[]');

    const getEntryById = (id) => entries.find((entry) => entry.sys.id === id);
    const getField = (entry, fieldName, locale) => entry?.fields?.[fieldName]?.[locale] || '';
    const getAssetUrlById = (id, language = appLanguage || 'es-VE') => {
      const asset = assets.find((a) => a.sys.id === id);
      if (!asset?.fields?.file) return '';

      const localizedFile = asset.fields.file[language];
      if (localizedFile?.url) {
        const url = localizedFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }

      const fallbackFile = Object.values(asset.fields.file)[0];
      if (fallbackFile?.url) {
        const url = fallbackFile.url;
        return url.startsWith('//') ? `https:${url}` : url;
      }

      return '';
    };

    const abortionEntry = getEntryById('3121gYh20FBtCODqTs5hZg');
    const largeCardEntry = getEntryById('6gKKYfGB3BofNvPapkoe6O');

    setPageState({
      headerTitle: getField(abortionEntry, 'headerTitle', appLanguage),
      pageTitle: getField(abortionEntry, 'pageTitle', appLanguage),
      extraText: getField(abortionEntry, 'extraText', appLanguage),
      extraText2: getField(abortionEntry, 'extraText2', appLanguage),
      extraText3: getField(abortionEntry, 'extraText3', appLanguage),

      smallCardTitle1: getField(abortionEntry, 'smallCardTitle1', appLanguage),
      smallCardDescription1: getField(abortionEntry, 'smallCardDescription1', appLanguage),
      smallCardTitle2: getField(abortionEntry, 'smallCardTitle2', appLanguage),
      smallCardDescription2: getField(abortionEntry, 'smallCardDescription2', appLanguage),

      largeCard1: {
        ovalText: getField(abortionEntry, 'pageTitle', appLanguage),
        blueTitle: getField(largeCardEntry, 'largeCardTitle1', appLanguage),
        description: getField(largeCardEntry, 'largeCardDescription1', appLanguage),
        images: [{ url: getAssetUrlById('5yFr4LjHnkBNmTaCjMR2pt') }],
      },
      largeCard2: {
        blackTitle: getField(largeCardEntry, 'largeCardTitle2', appLanguage),
      },
      largeCard3: {
        blackTitle: getField(largeCardEntry, 'largeCardTitle3', appLanguage),
        description: getField(largeCardEntry, 'largeCardDescription3', appLanguage),
      },
      largeCard4: {
        blackTitle: getField(largeCardEntry, 'largeCardTitle4', appLanguage),
        description: getField(largeCardEntry, 'largeCardDescription4', appLanguage),
      },
      largeCard5: {
        blackTitle: getField(largeCardEntry, 'largeCardTitle5', appLanguage),
        images: [{ url: getAssetUrlById('3fA0rOjpoQ7mIkVHSB7JoO') }],
      },

      headerImage: getAssetUrlById('4PRStO660MxXni9z6sY8j8'),
      arrowIconWhite: getAssetUrlById('5t0SZSeDrtBlIZ3o0Apjcu'),
      arrowIconDark: getAssetUrlById('h150pgUHcW5LIJwnFodWZ'),
      heartIcon: getAssetUrlById('740H3V1s40GxiaZiqj79MY'),
      image1: getAssetUrlById('5yFr4LjHnkBNmTaCjMR2pt'),
      image2: getAssetUrlById('3fA0rOjpoQ7mIkVHSB7JoO'),
    });
  }, [appLanguage]);

  return (
    
      <div className={styles.libraryAbortionMenuContainer}>
        <TopNavBarNew backgroundColor="#E3F4FF" breadcrumbColor="#333" />
        {/* Header Section */}
        <div className={styles.headerContainerContraception}>
          <HeaderCardNew
            title={pageState.headerTitle}
            image={pageState.headerImage}
            backgroundColor="#E3F4FF"
            borderRadius="0px"
          />
        </div>
        <div className={styles.bottomSpace}></div>
        <div className={styles.homePageContainer}>
        <FlexibleCard
          blueTitle={pageState.largeCard1.blueTitle}
          blackTitle={pageState.largeCard1.blackTitle}
          description={pageState.largeCard1.description}
          images={pageState.largeCard1.images}
          imagePosition="below-blue-title"
          imageWidth="160px"
          showOval={true}
          ovalText={pageState.largeCard1.ovalText}
          width="351px"
          borderRadius="10px"
        />

        {/* Render Individual Large Cards */}
        <FlexibleCard
          blackTitle={pageState.largeCard2.blackTitle}
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          blackTitle={pageState.largeCard3.blackTitle}
          description={pageState.largeCard3.description}
          width="351px"
          borderRadius="10px"
        />

        <FlexibleCard
          blackTitle={pageState.largeCard4.blackTitle}
          description={pageState.largeCard4.description}
          width="351px"
          borderRadius="10px"
        />


        <FlexibleCard
                  blackTitle={pageState.largeCard5.blackTitle}
                  images={pageState.largeCard5.images}
                  imagePosition="below-black-title"
                  width="351px"
                  borderRadius="10px"
                />



        {/* Extra Text Section */}
        <div className={styles.extraTitle}>{pageState.extraText}</div>

        {/* Feedback Card Section */}
        <FeedbackCard title={pageState.extraText2} appLanguage={appLanguage} />

        <div className={styles.leftAlignWrapper}>

        {/* Extra Text Section */}
        <div className={styles.extraTitletwo}>{pageState.extraText3}</div>

                {/* Render Small Cards Section */}
                {pageState.smallCardTitle1 && (
          <div className={styles.carouselContainer}>
            <CarouselSmallCard
                title={pageState.smallCardTitle1}
                extraText={pageState.smallCardDescription1}
                icon={pageState.arrowIconDark}
                backgroundColor="#E3F4FF"
                borderColor="#89D0FE"
                link="/contra-barrier-diaphragm"
            />
            <CarouselSmallCard
              title={pageState.smallCardTitle2}
              extraText={pageState.smallCardDescription1}
              icon={pageState.arrowIconDark}
              backgroundColor="#E3F4FF"
              borderColor="#89D0FE" 
              link="/contra-barrier-cervicalcap"
            />
          </div>
        )}
      </div>
      </div>
      <div className={styles.bottomSpace}></div>
      <BottomNavBarNew appLanguage={appLanguage}/>
    </div>
  );
}
